export const COOKIE_NAME = 'cookie_consent'

export const COOKIE_LIST = {
  required: true,
  functional: false
}
